import { withStyles } from "@material-ui/core/styles"
import React from "react"
import { Blocks } from "../index"
import styles from "./styles"

const BlockComp = ({ children, classes, block, event }) => {
  const normalizedName = (block.name || "").replace(/[^a-zA-Z0-9]/g, "")
  const Block = Blocks[block.name] || Blocks[normalizedName]
  return Block ? <Block data={block} event={event} /> : null
}

export default withStyles(styles, { withTheme: true })(BlockComp)



// WEBPACK FOOTER //
// ./src/components/Template/Block/index.jsx